export const GET_RETENTION_BOOKING_DATA_REQUEST = 'GET_RETENTION_BOOKING_DATA_REQUEST';
export const GET_RETENTION_BOOKING_DATA_SUCCESS = 'GET_RETENTION_BOOKING_DATA_SUCCESS';
export const GET_RETENTION_BOOKING_DATA_FAILURE = 'GET_RETENTION_BOOKING_DATA_FAILURE';
